import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "./../firebase.js";
import { loginRestaurant } from "../services/auth";
import {
    Mail,
    Lock,
    Eye,
    EyeOff,
} from "lucide-react";

export function Login() {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({

        email: "",

        password: "",

    });

    const [showPassword, setShowPassword] = useState(false);

    const [loading, setLoading] = useState(false);

    function handleChange(event) {

        setFormData({

            ...formData,

            [event.target.name]: event.target.value,

        });

    }

    async function handleSubmit(event) {

        event.preventDefault();

        if (loading) {

            return;

        }

        setLoading(true);

        try {

            // Sign in with Firebase
            const userCredential =
                await signInWithEmailAndPassword(
                    auth,
                    formData.email,
                    formData.password
                );

            // Get Firebase ID Token
            const idToken =
                await userCredential.user.getIdToken();

            // Login with backend
            const data =
                await loginRestaurant(idToken);

            console.log("data:", data);

            //--------------------------------------------------
            // Store primary outlet
            //--------------------------------------------------

            if (data.primaryOutletUid) {

                localStorage.setItem(

                    "selectedOutletUid",

                    data.primaryOutletUid

                );

            }

            //--------------------------------------------------
            // Redirect
            //--------------------------------------------------

            navigate(

                data.redirectTo

            );

        } catch (error) {

            console.error("Login failed:", error);

            alert(
                error.response?.data?.error ||
                error.message ||
                "Unable to log in."
            );

        } finally {

            setLoading(false);

        }

    }

    return (

        <div className="signup-page">

            {/* Left Panel */}

            <div className="signup-left">

                <div className="signup-brand">

                    <div className="signup-logo">

                        <img
                            src={require("./../imgs/nextgo-logo.png")}
                            alt="Next Go Logo"
                        />

                    </div>

                    <h2>

                        NextGo

                    </h2>

                </div>

                <div className="signup-left-content">

                    <h1>

                        Turn every purchase
                        <br />
                        into customer acquisition

                    </h1>

                    <p>

                        Place your offers on other businesses' checkouts and acquire new customers.

                    </p>

                    <div className="signup-dashboard-preview">

                        <img
                            src={require("./../imgs/dashboard-preview.png")}
                            alt="Dashboard Preview"
                        />

                    </div>

                </div>

            </div>

            {/* Right Panel */}

            <div className="signup-right">

                <div className="signup-top-link">

                    Don't have an account?

                    <a href="/signup">

                        Sign up

                    </a>

                </div>

                <div className="signup-form-container">

                    <h1>

                        Welcome back

                    </h1>

                    <p className="signup-subtitle">

                        Log in to manage your offers,
                        customers, and rewards.

                    </p>

                    <form onSubmit={handleSubmit}>

                        {/* Email */}

                        <label>

                            Email Address

                        </label>

                        <div className="input-group">

                            <Mail
                                size={20}
                                className="input-icon"
                            />

                            <input
                                type="email"
                                name="email"
                                placeholder="Enter your email address"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />

                        </div>

                        {/* Password */}

                        <label>

                            Password

                        </label>

                        <div className="input-group">

                            <Lock
                                size={20}
                                className="input-icon"
                            />

                            <input
                                type={
                                    showPassword
                                        ? "text"
                                        : "password"
                                }
                                name="password"
                                placeholder="Enter your password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                            />

                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() =>
                                    setShowPassword(!showPassword)
                                }
                            >

                                {showPassword
                                    ? <EyeOff size={20} />
                                    : <Eye size={20} />}

                            </button>

                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "14px",
                            }}
                        >

                            <a
                                href="/forgot-password"
                                style={{
                                    color: "#2162ad",
                                    textDecoration: "none",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                }}
                            >

                                Forgot password?

                            </a>

                        </div>

                        <button
                            type="submit"
                            className="signup-button"
                            disabled={loading}
                        >

                            {loading
                                ? "Logging In..."
                                : "Log In"}

                        </button>

                    </form>

                    <div className="signup-divider">

                        <span>

                            or

                        </span>

                    </div>

                    <button className="google-button">

                        <img
                            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                            alt="Google"
                        />

                        Continue with Google

                    </button>

                </div>

            </div>

        </div>

    );

}